<template lang="pug">
div
  //- 左側導覽列
  v-navigation-drawer(clipped fixed app v-model='drawer')
    v-list.mt-1(dense)
      v-list-tile
        .mt-2.flex: Logo(panel align='start' :light='!$store.state.preference.isDarkTheme')

      v-divider.my-3
      template(v-for='(i, index) in navbarItems')
        v-divider.my-3(v-if='i.isDivider' :key='index')
        v-subheader.grey--text.text--darken-1(v-else-if='i.isSubheader' :key='index' v-t='i.caption')

        //- Form 的選單
        v-list-group(no-action :prepend-icon="i.icon" v-else-if='i.name === `form`' :key='index')
          v-list-tile(slot='activator')
            v-list-tile-content: v-list-tile-title(v-t='i.caption')
          v-list-group(sub-group no-action v-for='period in formItems' :key='period.period')
            v-list-tile(slot='activator')
              v-list-tile-title {{ $tc("period", +period.period, { n: period.period}) }}
            v-list-tile(v-for='level in period.levels' :key='level.level' :to='{ name: `form`, params: { period: period.period, level: level.level }}' exact)
              v-list-tile-title {{ $t(convertLevelText(level.level)) }}

        //- Lottery 的選單
        v-list-group(no-action :prepend-icon="i.icon" v-else-if='i.name === `lottery`' :key='index')
          v-list-tile(slot='activator')
            v-list-tile-content: v-list-tile-title(v-t='i.caption')
          v-list-tile(v-for='period in lotteryItems' :key='period' :to='{ name: `lottery`, params: { period } }' exact)
            v-list-tile-title {{ $tc("period", +period, { n: period}) }}

        v-list-tile(
          v-else
          :to='{ name: i.name }'
          :exact='i.isExact'
          :key='index'
          active-class='primary--text'
          :class="{ 'primary--text': isThisPageConfig(i.name) }"
        )
          v-list-tile-action: v-icon(:color='isThisPageConfig(i.name) ? `primary` : ``') {{ i.icon }}
          v-list-tile-content: v-list-tile-title(v-t='i.caption')

  //- 上方工具列
  v-toolbar(app fixed dark flat clipped-left :dense='isMobile' style={ overflow: `hidden` } )
    v-toolbar-side-icon(@click.stop='drawer = !drawer')
    v-toolbar-title.pointer.toolbar-title(@click='toHome')
      v-slide-y-transition(leave-absolute hide-on-leave mode='out-in')
        .school-name(v-if='!isTitleShow || !isMobile || isHome') {{ schoolName }}
      v-slide-y-reverse-transition(leave-absolute hide-on-leave)
        .page-title(v-if='isTitleShow && !isHome && title')
          v-icon.icon(small) fas fa-caret-right
          .text(v-t='title')

    v-spacer
    v-tooltip(bottom)
      v-fade-transition(slot='activator')
        v-btn.ma-0(icon flat @click='toggleDebugMode(false)' v-if='isDebugMode' color='orange'): v-icon fab fa-dev
      span(v-t='"exitDebugMode"')
    v-menu(offset-y)
      v-btn(slot='activator' flat fab)
        v-avatar(:size='30'): v-img(:src='$store.getters.cover')
      v-list
        v-list-tile(avatar :to='{ name: `account` }' active-class)
          v-list-tile-avatar: img(:src='$store.getters.cover')
          v-list-tile-content
            v-list-tile-title {{ schoolName }}
            v-list-tile-sub-title {{ schoolId }}
      v-divider
      v-list
        v-list-tile(@click='toggleDarkTheme')
          v-list-tile-avatar: v-icon brightness_medium
          v-list-tile-content: v-list-tile-title
            span(v-t='"darkTheme"')
            span(v-t='isDarkTheme ? "on" : "off"')
        v-list-tile(:to='{ name: `preference` }')
          v-list-tile-avatar: v-icon fas fa-cogs
          v-list-tile-content: v-list-tile-title(v-t='"preference"')
        v-list-tile(:to='{ name: `support` }')
          v-list-tile-avatar: v-icon fas fa-info-circle
          v-list-tile-content: v-list-tile-title(v-t='"about"')
      v-divider
      v-list
        v-list-tile(@click='logout')
          v-list-tile-avatar: v-icon fas fa-sign-out-alt
          v-list-tile-content: v-list-tile-title(v-t='"logout"')
</template>

<script>
import { throttle } from 'throttle-debounce'
import Logo from '@/components/Logo.vue'

import auth from '@/assets/js/auth'

export default {
  name: 'Navbar',
  metaInfo () {
    return {
      afterNavigation: (info) => {
        this.title = info.titleChunk
      },
    }
  },
  data () {
    return {
      drawer: null,
      isTitleShow: false,
      title: null,
    }
  },
  mounted () {
    this.setOnScroll()
  },
  methods: {
    toggleDarkTheme () {
      this.$store.commit('toggleDarkTheme')
    },
    logout () {
      auth.clearAuth()
      this.$store.commit('clearUser')
      this.$router.push({ name: 'login' })
    },
    toHome () {
      if (this.isTitleShow) window.scrollTo({ top: 0, behavior: 'smooth' })
      else this.$router.push({ name: 'home' })
    },
    setOnScroll () {
      const throttled = throttle(300, () => {
        const top = document.scrollingElement.scrollTop || document.documentElement.scrollTop
        this.isTitleShow = top > 100
      })

      window.addEventListener('scroll', throttled)
      this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', throttled))
    },
    isThisPageConfig (_) {
      return [this.$route.name, _].every(_ => _ === 'config')
    },
  },
  computed: {
    schoolName () {
      return this.$store.getters.schoolName
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    formInfo () {
      return this.$store.state.formInfo
    },
    lotteryInfo () {
      return this.$store.state.lotteryInfo
    },
    // 生成左側 Forms 選單項目（已排序）
    formItems () {
      const formInfo = this.formInfo || {}
      return Object.keys(formInfo).sort((a, b) => b - a).map(i => ({
        period: +i,
        levels: Object.keys(formInfo[i]).sort((a, b) => a - b).map(j => ({
          level: +j,
          groups: formInfo[i][j].groups,
        })),
      }))
    },
    // 生成左側 Lottery 選單項目（已排序）
    lotteryItems () {
      return this.lotteryInfo
        ? [...this.lotteryInfo].sort((a, b) => b - a)
        : []
    },
    isMobile () {
      return this.$vuetify.breakpoint.xs
    },
    isHome () {
      return this.$route.name === 'home'
    },
  },
  components: {
    Logo,
  },
}
</script>

<style scoped lang="sass">
$title-space: .75rem
.toolbar-title
  display: flex
  align-items: center
  .school-name
    margin-right: $title-space
  .page-title
    display: flex
    align-items: center
    opacity: .7
    .text
      margin-left: $title-space
      transform: scale(.8)
      transform-origin: left

</style>

<i18n src="@/lang/components/navbar.json"></i18n>
